// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3833) return "static/css/3833.66236e776878a8443753.css";
	if (chunkId === 6204) return "static/css/receiver.d34f1d4efce43ae0fdfd.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6559":"b2e5d3c087a7fdcef4f6","6594":"dde7397c80c026292b38","6918":"dde7397c80c026292b38","7076":"dde7397c80c026292b38"}[chunkId] + ".chunk.css";
};